@if (video) {
  <div
    id="videooverlay-container"
    [class.embed-mode]="embedMode"
    [class.comments-overlay]="commentsOverlay && shouldShowCommentsPanel()"
    [class.comments-hidden]="embedMode && !shouldShowCommentsPanel()"
    [class.minimized]="minimized"
    [class.dock-right]="dockRight"
    [class.dock-left]="!dockRight"
    [class.pinned-to-bottom]="pinnedToBottom"
    [class.over-modal]="overModal"
    [class.sidebar-resizing]="resizing || overlayResizing"
  >
    <!-- <fa-icon (click)="close()" icon="times" class="circle-icon-btn close-btn"></fa-icon> -->
    @if (minimized) {
      <div class="minimized-buttons d-flex justify-content-between">
        <button class="small-btn force-light" (click)="dockRight = !dockRight">{{ dockRight ? ("video_player.dock_left" | translate) : ("video_player.dock_right" | translate) }}</button>
        <div class="d-flex">
          <button class="fa-button" (click)="maximizeVideoPlayer()" [ngbTooltip]="'video_player.expand_video' | translate" container="body" triggers="hover">
            <fa-icon icon="maximize" class="circle-icon-btn m-r-5"></fa-icon>
            <span class="sr-only">{{ "video_player.expand_video" | translate }}</span>
          </button>
          <button class="fa-button" (click)="close()" [ngbTooltip]="'video_player.close_video' | translate" container="body" triggers="hover">
            <fa-icon icon="times" class="circle-icon-btn m-r-5"></fa-icon>
            <span class="sr-only">{{ "video_player.close_video" | translate }}</span>
          </button>
        </div>
      </div>
    }
    @if (!loadingComments) {
      <div id="videooverlay" #videoOverlay role="dialog" aria-modal="true" [attr.aria-label]="dialogAriaLabel" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
        <div class="video-main">
          @if (shouldShowVideo && pendingLiveEvent) {
            <!-- Livestream opened before showtime: hold on the shared countdown (same UI the
                 fender.com embed uses) instead of the platform's bare "starts in X" screen. -->
            <fui-livestream-countdown
              [event]="pendingLiveEvent"
              [signupEnabled]="signupEnabled"
              [signupConfig]="signupConfigCountdown"
              [signupEventId]="signupEventId"
              [autoOpenTrailer]="autoOpenTrailer"
              (wentLive)="onLivestreamWentLive()"
            ></fui-livestream-countdown>
          }
          @if (shouldShowVideo && !pendingLiveEvent) {
            @if (video.type == "youtube") {
              <div style="height: 100%; width: 100%">
                <youtube-player [playerVars]="playerVars" height="100%" width="100%" #ytPlayer [videoId]="video.id"></youtube-player>
              </div>
            }
            @if (video.type == "vimeo") {
              <iframe [src]="url | safe" width="100%" height="100%" id="vimeo_frame" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            }
          }
          @if (!shouldShowVideo) {
            <div class="h-100 d-flex justify-content-center align-items-center text-center">
              <div style="max-width: 600px; margin: 10px">
                <div
                  style="
                    background-image: url(https://pae-web.presonusmusic.com/uploads/products/media/images/presonus-sphere-website-0321-07.png);
                    background-size: cover;
                    background-position: center;
                    padding: 150px 50px;
                    border-radius: 20px;
                  "
                >
                  <h2 class="brandfont-bold c-white" style="text-shadow: 0px 0px 5px black">{{ "newdash.exclusive_content_livestreams" | translate | uppercase }}</h2>
                </div>
                <!-- <p class="m-t-20" [innerHTML]="'newdash.exclusive_content_slug' | translate"></p> -->
                <h3 class="brandfont-bold">{{ "video_player.video_only_available_to_subscribers" | translate: { brand: env.studioOnePlusBrandName } }}</h3>
                <p class="m-t-20">
                  {{ "video_player.video_subscribers_description" | translate: { brand: env.studioOnePlusBrandName } }}
                </p>
                <button class="btn btn-primary" (click)="upgrade()">{{ "newdash.get_sphere" | translate: { subName: env.studioOnePlusBrandName } }}</button>
              </div>
            </div>
          }
        </div>
        @if (shouldShowCommentsPanel()) {
          <div class="resize-handle" (mousedown)="onResizeMouseDown($event)">
            <div class="resize-handle-indicator"></div>
          </div>
          <div
            class="comments-container"
            [style.width.px]="commentsOverlay && landscape ? overlayWidth : landscape && !pinnedToBottom ? sidebarWidth : null"
            [style.height.px]="commentsOverlay && landscape ? overlayHeight : null"
            [style.max-height.px]="overlayMaxHeight"
          >
            <div class="video-sidebar-header">
              <div class="video-sidebar-header-content">
                <!-- Embed panel with several features on: a tab per enabled feature (DENG-893).
                     With one (or none) we just show its name, like the in-app player. -->
                @if ((embedMode || hasLivestreamPanel) && panelFeatures.length > 1) {
                  <div class="embed-tabs" role="tablist">
                    @for (f of panelFeatures; track f.id) {
                      <button type="button" class="embed-tab" role="tab" [class.active]="selectedSection === f.id" [attr.aria-selected]="selectedSection === f.id" (click)="selectSection(f.id)">
                        <fa-icon [icon]="f.icon" class="m-r-5"></fa-icon>
                        {{ f.label }}
                      </button>
                    }
                  </div>
                } @else {
                  <div class="t-14 bold c-white">{{ selectedSectionWord }}</div>
                }
                <div>
                  @if (landscape) {
                    <button class="fa-button" (click)="toggleCommentsOverlay()" [ngbTooltip]="commentsOverlay ? 'Dock to side' : 'Overlay on video'" container="body" triggers="hover">
                      <fa-icon [icon]="commentsOverlay ? 'table-columns' : 'clone'" class="circle-icon-btn m-r-5"></fa-icon>
                      <span class="sr-only">{{ commentsOverlay ? "Dock to side" : "Overlay on video" }}</span>
                    </button>
                  }
                  <button class="fa-button" (click)="hideEmbedComments()" [ngbTooltip]="embedMode ? 'Hide' : 'Hide comments'" container="body" triggers="hover">
                    <fa-icon [icon]="pinnedToBottom || !landscape ? 'chevron-down' : 'chevron-right'" class="circle-icon-btn m-r-5"></fa-icon>
                    <span class="sr-only">{{ embedMode ? "Hide" : "Hide comments" }}</span>
                  </button>

                  @if (!embedMode) {
                    <button class="fa-button" (click)="minimizeVideoPlayer()" [ngbTooltip]="'video_player.minimize_video' | translate" container="body" triggers="hover">
                      <fa-icon icon="minimize" class="circle-icon-btn m-r-5"></fa-icon>
                      <span class="sr-only">{{ "video_player.minimize_video" | translate }}</span>
                    </button>
                    <button #closeButton id="close-modal-button" class="fa-button" (click)="close()" [ngbTooltip]="'video_player.close_video' | translate" container="body" triggers="hover">
                      <fa-icon icon="times" class="circle-icon-btn m-r-5"></fa-icon>
                      <span class="sr-only">{{ "video_player.close_video" | translate }}</span>
                    </button>
                  }
                </div>
              </div>
              @if (presonusVideo && !embedMode) {
                <myp-segmented-bar [videoMode]="true" [isUsedAsTab]="true" (selected)="selectSection($event.id)" [options]="videoPlayerTabs"></myp-segmented-bar>
              }
            </div>
            <div class="video-sidebar-content">
              @if (selectedSection == "details") {
                <div role="tabpanel" id="tabpanel-details" tabindex="0" aria-labelledby="tab-details" class="video-details c-white trans-bg border-radius10 h-full">
                  <div class="p-10">
                    <fui-heading color="white" [text]="presonusVideo?.title" [level]="5"></fui-heading>
                    <fui-heading color="white" [text]="'video_player.description_label' | translate" [level]="6"></fui-heading>
                    @if (presonusVideo?.description) {
                      <div class="lighter-link" [innerHTML]="presonusVideoDescriptionHtml | safe: 'html'"></div>
                    }
                    <hr />
                    @if (lesson) {
                      @if (lessonNextVideo) {
                        <span>{{ "video_player.watching_video_from_lesson" | translate: { index: lessonWatchingIndex + 1, lesson: lesson.title } }}</span>
                      }
                      @if (!lessonNextVideo) {
                        <span>{{ "video_player.watching_final_video_in_lesson" | translate: { lesson: lesson.title } }}</span>
                      }
                      <br />
                      <button class="small-btn force-light" (click)="goToLesson()">{{ "video_player.go_to_lesson" | translate }}</button>
                      <br />
                      <br />
                      @if (lessonNextVideo) {
                        {{ "video_player.next_up_in_lesson" | translate }}
                        <div class="trans-bg p-10 border-radius10">
                          <myp-video-grid-item [video]="lessonNextVideo" [lessonID]="lesson ? lesson.id : null"></myp-video-grid-item>
                        </div>
                        <hr />
                      }
                      @if (lessonPrevVideo) {
                        <div class="m-t-20">
                          {{ "video_player.previous_video_in_lesson" | translate: { lesson: lesson.title } }}
                          <br />
                          <button class="brandfont-bold link" (click)="showPreviousVideo()">
                            <fa-icon class="link" icon="chevron-left"></fa-icon>
                            {{ lessonPrevVideo.title }}
                          </button>
                          <hr />
                        </div>
                      }
                    }
                    @if (presonusVideo?.tags && presonusVideo?.tags.length) {
                      <h2 class="t-14 bold">{{ "video_player.tags_label" | translate }}</h2>
                      @if (presonusVideo?.tags) {
                        <div class="video-tags">
                          @for (tag of presonusVideo.tags; track tag) {
                            <span class="pill sm trans force-dark">#{{ tag.title }}</span>
                          }
                        </div>
                      }
                      <hr />
                    }
                    @if (presonusVideo?.products && presonusVideo?.products.length) {
                      <h2 class="t-14 bold">{{ "video_player.related_products" | translate }}</h2>
                      @for (product of presonusVideo.products; track product) {
                        <myp-list-item
                          [forceDarkMode]="true"
                          [hoverState]="false"
                          [title]="product.title"
                          [includeChevron]="productService.productsByProductID[product.id]"
                          [showImage]="!!product.imageUrl"
                          [photo]="product.imageUrl"
                          [photoAlt]="product.title"
                          [imageRound]="false"
                          [imageBorder]="false"
                          (itemClicked)="goToProduct(product)"
                        ></myp-list-item>
                      }
                      <hr />
                    }
                  </div>
                </div>
              }
              @if (selectedSection == "comments") {
                <div role="tabpanel" id="tabpanel-comments" tabindex="0" aria-labelledby="tab-comments" class="force-dark h-full">
                  @if (canShowVideoComments()) {
                    <myp-chat
                      [fullHeight]="true"
                      [commentsUI]="true"
                      [sendOnEnter]="true"
                      (commentFlagged)="flagComment($event)"
                      (commentUnflagged)="unflagComment($event)"
                      (commentLiked)="likeComment($event)"
                      [enableDirectMessages]="false"
                      #chatCmp
                      (editMessage)="editComment($event)"
                      (deleteMessage)="deleteComment($event)"
                      (adminDeleteMessage)="adminDeleteComment($event)"
                      (flagCleared)="clearFlag($event)"
                      (messageSent)="addComment($event)"
                      [messages]="communityService.comments"
                      [parentThreadMap]="communityService.parentThreadMap"
                      [forceDark]="true"
                    ></myp-chat>
                  } @else {
                    <div class="d-flex flex-column align-items-center justify-content-center h-full p-20 text-center">
                      <p class="c-white m-b-20">Sign in or create an account to view or post comments.</p>
                      <button type="button" class="btn btn-primary" (click)="promptSignInForComments()">Sign in or create account</button>
                    </div>
                  }
                </div>
              }
              @if (selectedSection == "mynotes") {
                <div role="tabpanel" id="tabpanel-mynotes" tabindex="0" aria-labelledby="tab-mynotes" class="last-focusable-element force-dark h-full">
                  <myp-video-notes [fullHeight]="true" [videoId]="presonusVideo.id" [activeTime]="activeTime" (playVideoFrom)="seekTo($event)"></myp-video-notes>
                </div>
              }
              @if (selectedSection == "shop" && shopContent) {
                <!-- Shopping rail (embed): product data posted in by the host page. Links open on the
                     top window so the PDP/cart flow happens on fender.com where the cart lives. -->
                <div role="tabpanel" id="tabpanel-shop" tabindex="0" class="embed-shop h-full">
                  <div class="embed-shop__intro">
                    @if (shopContent.heading) {
                      <h2 class="embed-shop__heading">{{ shopContent.heading }}</h2>
                    }
                    @if (shopContent.blurb) {
                      <p class="embed-shop__blurb">{{ shopContent.blurb }}</p>
                    }
                    @if (shopContent.shopAllUrl) {
                      <a class="embed-shop__all" [href]="shopContent.shopAllUrl" target="_top" rel="noopener">Shop All</a>
                    }
                  </div>
                  <div class="embed-shop__grid">
                    @for (product of shopContent.products; track $index) {
                      <a class="embed-shop__card" [href]="product.url || null" target="_top" rel="noopener">
                        @if (product.image) {
                          <img class="embed-shop__img" [src]="product.image" [alt]="product.title" loading="lazy" />
                        }
                        <div class="embed-shop__name">{{ product.title }}</div>
                        @if (product.price) {
                          <div class="embed-shop__price">{{ product.price }}</div>
                        }
                        @if (product.colors) {
                          <div class="embed-shop__colors">{{ product.colors }}</div>
                        }
                      </a>
                    }
                  </div>
                </div>
              }
              @if (selectedSection == "signup") {
                <!-- Sign-up (email capture): shared self-contained form (also used in the countdown
                     modal). No host modal — STUB submit until the capture endpoint is decided. -->
                <div role="tabpanel" id="tabpanel-signup" tabindex="0" class="h-full">
                  <fui-embed-signup [config]="signupConfig" [eventId]="signupEventId" [state]="'livestream'"></fui-embed-signup>
                </div>
              }
            </div>
            @if (commentsOverlay && landscape) {
              <div class="overlay-resize-handle" (mousedown)="onOverlayResizeMouseDown($event)" role="separator" aria-label="Resize comments panel" aria-orientation="vertical"></div>
            }
          </div>
        }
      </div>
    }
    <!-- Comments hidden: the panel that normally hosts the close/minimize chrome is gone, so the
         way back in AND the way out both live here. Labels enter expanded, then collapse in step
         into matching icon bubbles. -->
    <!-- Floating pills when the panel is collapsed. During the in-app countdown the panel is hidden,
         so the Close-video pill always shows and the Show-Comments pill rides along only when comments
         are enabled (sign-up stays on the countdown's own button). -->
    @if (shouldShowCommentsButton() || (pendingLiveEvent && !embedMode && commentsHidden)) {
      <div class="video-pill-actions" [class.collapsed]="showCommentsPillCollapsed">
        @if (shouldShowCommentsButton()) {
          <button type="button" class="video-pill-btn" (click)="showEmbedComments()" [attr.aria-label]="panelTriggerLabel">
            <fa-icon [icon]="panelTriggerIcon"></fa-icon>
            <span class="video-pill-btn__label">{{ panelTriggerLabel }}</span>
          </button>
        }
        <!-- The embed is chrome-less by design — there's nothing to close it back to. -->
        @if (!embedMode) {
          <button type="button" class="video-pill-btn" (click)="close()" aria-label="Close video">
            <fa-icon icon="times"></fa-icon>
            <span class="video-pill-btn__label">Close video</span>
          </button>
        }
      </div>
    }
    @if (commentsHidden && hiddenIncomingToasts.length) {
      <div class="hidden-comment-stack" aria-live="polite">
        @for (toast of hiddenIncomingToasts; track toast.id) {
          <button type="button" class="hidden-comment-toast" [class.visible]="toast.visible" [class.exiting]="toast.exiting" (click)="showEmbedComments()" [attr.aria-label]="'Open comments'">
            <img [src]="toast.comment.author?.photo || './assets/images/default_avatar.jpg'" [alt]="(toast.comment.author?.name || '') + ' profile photo'" class="hidden-comment-toast__photo" />
            <div class="hidden-comment-toast__body">
              <div class="hidden-comment-toast__name">{{ toast.comment.author?.name }}</div>
              <div class="hidden-comment-toast__text" [innerHTML]="toast.comment.htmlMessage | safe: 'html'"></div>
            </div>
          </button>
        }
        <button type="button" class="hidden-comment-stack__cta" (click)="showEmbedComments()">
          <fa-icon icon="comment" class="m-r-5"></fa-icon>
          View all comments
        </button>
      </div>
    }
  </div>
}
